var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 0.997413456,
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1554C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441327065,
    stopColor: "#1E23B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5811B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "gradient_2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1554C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441327065,
    stopColor: "#1E23B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997413456,
    stopColor: "#5811B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 0.497360647,
    id: "gradient_3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1554C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497360647,
    stopColor: "#231494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5212B5"
  })), /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    id: "filter_1"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8156863 0 0 0 0 0.8156863 0 0 0 0 0.8156863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect0_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect0_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.999 0L92.001 0Q92.1974 0 92.3935 0.00963514Q92.5896 0.0192703 92.785 0.0385174Q92.9805 0.0577644 93.1747 0.0865771Q93.3689 0.11539 93.5615 0.153699Q93.7541 0.192007 93.9446 0.23972Q94.1351 0.287433 94.323 0.344434Q94.5109 0.401436 94.6958 0.467589Q94.8807 0.533742 95.0621 0.608888Q95.2435 0.684033 95.421 0.76799Q95.5985 0.851946 95.7717 0.944512Q95.9449 1.03708 96.1133 1.13803Q96.2817 1.23898 96.445 1.34807Q96.6083 1.45717 96.766 1.57414Q96.9237 1.69112 97.0755 1.81569Q97.2273 1.94026 97.3728 2.07213Q97.5183 2.204 97.6571 2.34285Q97.796 2.4817 97.9279 2.6272Q98.0597 2.7727 98.1843 2.92449Q98.3089 3.07628 98.4258 3.234Q98.5428 3.39172 98.6519 3.55499Q98.761 3.71826 98.862 3.88669Q98.9629 4.05512 99.0555 4.2283Q99.148 4.40148 99.232 4.57899Q99.316 4.7565 99.3911 4.93791Q99.4662 5.11933 99.5324 5.30422Q99.5986 5.4891 99.6556 5.67701Q99.7126 5.86492 99.7603 6.0554Q99.808 6.24588 99.8463 6.43847Q99.8846 6.63106 99.9134 6.8253Q99.9422 7.01954 99.9615 7.21496Q99.9807 7.41038 99.9904 7.60651Q100 7.80264 100 7.999L100 92.001Q100 92.1974 99.9904 92.3935Q99.9807 92.5896 99.9615 92.785Q99.9422 92.9805 99.9134 93.1747Q99.8846 93.3689 99.8463 93.5615Q99.808 93.7541 99.7603 93.9446Q99.7126 94.1351 99.6556 94.323Q99.5985 94.5109 99.5324 94.6958Q99.4662 94.8807 99.3911 95.0621Q99.3159 95.2435 99.232 95.421Q99.148 95.5985 99.0555 95.7717Q98.9629 95.9449 98.862 96.1133Q98.761 96.2817 98.6519 96.445Q98.5428 96.6083 98.4258 96.766Q98.3089 96.9237 98.1843 97.0755Q98.0597 97.2273 97.9279 97.3728Q97.796 97.5183 97.6571 97.6571Q97.5183 97.796 97.3728 97.9279Q97.2273 98.0597 97.0755 98.1843Q96.9237 98.3089 96.766 98.4258Q96.6083 98.5428 96.445 98.6519Q96.2817 98.761 96.1133 98.862Q95.9449 98.9629 95.7717 99.0555Q95.5985 99.148 95.421 99.232Q95.2435 99.316 95.0621 99.3911Q94.8807 99.4662 94.6958 99.5324Q94.5109 99.5986 94.323 99.6556Q94.1351 99.7126 93.9446 99.7603Q93.7541 99.808 93.5615 99.8463Q93.3689 99.8846 93.1747 99.9134Q92.9805 99.9422 92.785 99.9615Q92.5896 99.9807 92.3935 99.9904Q92.1974 100 92.001 100L7.999 100Q7.80264 100 7.60651 99.9904Q7.41038 99.9807 7.21496 99.9615Q7.01954 99.9422 6.8253 99.9134Q6.63106 99.8846 6.43847 99.8463Q6.24588 99.808 6.0554 99.7603Q5.86492 99.7126 5.67701 99.6556Q5.4891 99.5985 5.30422 99.5324Q5.11933 99.4662 4.93791 99.3911Q4.7565 99.3159 4.57899 99.232Q4.40148 99.148 4.2283 99.0555Q4.05512 98.9629 3.88669 98.862Q3.71826 98.761 3.55499 98.6519Q3.39172 98.5428 3.234 98.4258Q3.07628 98.3089 2.92449 98.1843Q2.7727 98.0597 2.6272 97.9279Q2.4817 97.796 2.34285 97.6571Q2.204 97.5183 2.07213 97.3728Q1.94026 97.2273 1.81569 97.0755Q1.69112 96.9237 1.57414 96.766Q1.45717 96.6083 1.34807 96.445Q1.23898 96.2817 1.13803 96.1133Q1.03708 95.9449 0.944512 95.7717Q0.851946 95.5985 0.76799 95.421Q0.684033 95.2435 0.608888 95.0621Q0.533742 94.8807 0.467589 94.6958Q0.401436 94.5109 0.344434 94.323Q0.287433 94.1351 0.23972 93.9446Q0.192007 93.7541 0.153699 93.5615Q0.11539 93.3689 0.0865771 93.1747Q0.0577644 92.9805 0.0385174 92.785Q0.0192703 92.5896 0.00963514 92.3935Q0 92.1974 0 92.001L0 7.999Q0 7.80264 0.00963514 7.60651Q0.0192703 7.41038 0.0385174 7.21496Q0.0577644 7.01954 0.0865771 6.8253Q0.11539 6.63106 0.153699 6.43847Q0.192007 6.24588 0.23972 6.0554Q0.287433 5.86492 0.344434 5.67701Q0.401436 5.4891 0.467589 5.30422Q0.533742 5.11933 0.608888 4.93791Q0.684033 4.7565 0.76799 4.57899Q0.851946 4.40148 0.944512 4.2283Q1.03708 4.05512 1.13803 3.88669Q1.23898 3.71826 1.34807 3.55499Q1.45717 3.39172 1.57414 3.234Q1.69112 3.07628 1.81569 2.92449Q1.94026 2.7727 2.07213 2.6272Q2.204 2.4817 2.34285 2.34285Q2.4817 2.204 2.6272 2.07213Q2.7727 1.94026 2.92449 1.81569Q3.07628 1.69112 3.234 1.57414Q3.39172 1.45717 3.55499 1.34807Q3.71826 1.23898 3.88669 1.13803Q4.05512 1.03708 4.2283 0.944512Q4.40148 0.851946 4.57899 0.76799Q4.7565 0.684033 4.93791 0.608888Q5.11933 0.533742 5.30422 0.467589Q5.4891 0.401436 5.67701 0.344434Q5.86492 0.287433 6.0554 0.23972Q6.24588 0.192007 6.43847 0.153699Q6.63106 0.11539 6.8253 0.0865771Q7.01954 0.0577644 7.21496 0.0385174Q7.41038 0.0192703 7.60651 0.00963514Q7.80264 0 7.999 0Z",
    transform: "matrix(-1 0 0 1 100 0)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26C0 11.663 11.664 0 26 0C40.336 0 52 11.663 52 26C52 40.337 40.336 52 26 52C11.664 52 0 40.337 0 26ZM2 26C2 39.233 12.767 50 26 50C39.233 50 50 39.233 50 26C50 12.767 39.233 2 26 2C12.767 2 2 12.767 2 26Z",
    transform: "translate(24 23)",
    id: "Shape",
    fill: "url(#gradient_1)",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 12L14.5 12L14.5 1C14.5 0.447 14.052 0 13.5 0C12.948 0 12.5 0.447 12.5 1L12.5 12L1 12C0.448 12 0 12.447 0 13C0 13.553 0.448 14 1 14L12.5 14L12.5 26C12.5 26.553 12.948 27 13.5 27C14.052 27 14.5 26.553 14.5 26L14.5 14L26 14C26.552 14 27 13.553 27 13C27 12.447 26.552 12 26 12Z",
    transform: "translate(36.5 36)",
    id: "Path",
    fill: "url(#gradient_2)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "url(#gradient_3)",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeDasharray: "4 7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.18974dfcff6d52021ffe0fb812871fee.svg";
export { ForwardRef as ReactComponent };